import React from 'react';
import { APP_PUBLIC_URL, ROUTES } from './common/constants/defaultStaticUrls';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { routing } from './routing';
import { RootLayout } from './components/RootLayout/RootLayout';

export const Router: React.FC = () => (
  <BrowserRouter basename={APP_PUBLIC_URL}>
    <Routes>
      <Route element={<RootLayout />}>
        {routing.map(({ path, element }) => (
          <Route key={path} index={path === ROUTES.HOME} path={path} element={element} />
        ))}
      </Route>
    </Routes>
  </BrowserRouter>
);
